<template>
  <div>
    <v-flex xs12>
      <v-flex xs12>
        <v-card>
          <v-toolbar card prominent>
            <v-toolbar-title>Thông tin tài khoản</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu offset-y>
              <v-btn slot="activator" icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <!-- <v-list-tile @click="isEdit = true">
                  <v-list-tile-title>Chỉnh sửa thông tin</v-list-tile-title>
                </v-list-tile>-->
                <v-list-tile @click="changePasswordDialog = true">
                  <v-list-tile-title>Đổi mật khẩu</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="logout()">
                  <v-list-tile-title>Đăng xuất</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
            <v-btn icon @click="close()">
              <v-icon >close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text>
            <v-form class="form-content" v-model="formValid" ref="form">
              <v-text-field
                prepend-icon="person"
                :disabled="!isEdit"
                v-model="form.name"
                :rules="[validate.required]"
              ></v-text-field>
              <v-text-field prepend-icon="phone" disabled v-model="form.phone"></v-text-field>
              <v-text-field
                prepend-icon="email"
                :disabled="!isEdit"
                v-model="form.email"
                :rules="[validate.required, validate.email]"
              ></v-text-field>
              <v-text-field prepend-icon="place" :disabled="!isEdit" v-model="form.address"></v-text-field>
              <div class="right" v-show="isEdit">
                <v-btn flat @click="isEdit = false">Hủy</v-btn>
                <v-btn color="success" @click="submit()" :loading="isLoading">Cập nhật</v-btn>
              </div>
              <div class="clear"></div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-flex>
    <div class="text-xs-center">
      <v-dialog v-model="changePasswordDialog" width="500">
        <v-card>
          <v-toolbar card prominent color="grey lighten-3">
            <v-toolbar-title>Đổi mật khẩu</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="changePasswordDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <change-password @show="changePasswordDialog = $event"/>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import ChangePassword from './changepassword';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import validate from '@/utils/validate';

export default {
  name: 'account-infomation',
  components: {
    ChangePassword
  },
  data () {
    return {
      formValid: false,
      validate: validate,
      isEdit: false,
      isLoading: false,
      changePasswordDialog: false,
      form: {
        name: '',
        phone: '',
        email: '',
        address: ''
      },
      dialog: false
    };
  },
  computed: {
    ...mapGetters(['loggedUser'])
  },
  watch: {
    loggedUser () {
      this.bindLoggedUser();
    }
  },
  created () {
    this.bindLoggedUser();
  },
  methods: {
    ...mapActions(['updateProfile']),
    ...mapMutations(['SET_LOGGED_USER']),
    bindLoggedUser () {
      if (this.loggedUser) {
        this.form.name = this.loggedUser.name;
        this.form.phone = this.loggedUser.phone;
        this.form.email = this.loggedUser.email;
        this.form.address = this.loggedUser.address;
      }
    },
    submit () {
      if (this.formValid) {
        this.isLoading = true;
        this.updateProfile(this.form)
          .then(_ => {
            window.getApp.showMessage('Cập nhật thành công');
            this.isLoading = false;
            let user = Object.assign({}, this.loggedUser);
            user.name = this.form.name;
            user.email = this.form.email;
            user.address = this.form.address;

            this.SET_LOGGED_USER(user);
            this.isEdit = false;
            this.close();
          })
          .catch(_ => {
            window.getApp.showMessage('Cập nhật thất bại', 'error');
          });
      }
    },
    logout () {
      window.getApp.$emit('APP_LOGOUT');
    },
    close () {
      this.$emit('show', false);
    }
  }
};
</script>


<style scoped>
.form-content {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/account/components/profile.vue